import CashTransactions from '@/features/shiftCloseouts/components/ShiftCloseoutForm/parts/ShiftCloseoutSummary/parts/CashTransactions'
import Handover from '@/features/shiftCloseouts/components/ShiftCloseoutForm/parts/ShiftCloseoutSummary/parts/Handover'
import Overview from '@/features/shiftCloseouts/components/ShiftCloseoutForm/parts/ShiftCloseoutSummary/parts/Overview'
import {
    DailyShiftCloseout,
    ShiftCloseoutPreviewData,
    ShiftCloseoutReconciliation,
} from '@/features/shiftCloseouts/types'
import { calculateHandover } from '@/features/shiftCloseouts/utils/calculateHandover'
import { FC } from 'react'
import { StyleSheet, View } from 'react-native'

interface ShiftCloseoutSummaryProps {
    paymentMethods: DailyShiftCloseout['paymentMethods']
    preview: ShiftCloseoutPreviewData
    reconciliation: ShiftCloseoutReconciliation
}

const ShiftCloseoutSummary: FC<ShiftCloseoutSummaryProps> = ({
    paymentMethods,
    preview,
    reconciliation,
}) => {
    const handover = calculateHandover(preview.handover, paymentMethods, reconciliation.differences)

    return (
        <View style={styles.container}>
            <Overview reconciliation={reconciliation} totalAmount={preview.totalAmount} />
            <Handover handover={handover} />
            <CashTransactions currency={preview.currency} transactions={preview.cashTransactions} />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        gap: 32,
    },
})

export default ShiftCloseoutSummary
